import {MBAnalytics} from "@docsapp/analytics";
import { EVENT_PLATFORMS, HR_WIN_SERVICE_NAME, SNOWPLOW_EVENTS_SCHEMA } from "./constants";
import {
	CLEVERTAP,
	EVENTSLOG,
	NETCORE,
	SNOWPLOW,
} from "@docsapp/constants";

// Conditionally exclude EVENTSLOG (Druid) platform if disabled
const filterDruidPlatforms = (platforms) => {
	const isDruidDisabled = process.env.REACT_APP_DISABLE_DRUID == 'true';
	return isDruidDisabled ? platforms.filter(platform => platform !== EVENTSLOG) : platforms;
};

const analyticsPlugins = filterDruidPlatforms([
	SNOWPLOW,
	CLEVERTAP,
	EVENTSLOG,
	NETCORE,
]);

const __MB_Analytics = new MBAnalytics(
	analyticsPlugins,
	process.env.appVersion,
);

// removing the keys with undefined and null values, which are causing for event failures
const cleanPayload = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));

const sendAnalyticsEvents = (name, payload, contexts) => {
	try {
		if(!payload.timestamp){
			payload.timestamp = new Date().toISOString();
		}
		payload = cleanPayload(payload);
		const { screenName, service_name } = payload;
		if (!service_name) {
			payload.service_name = HR_WIN_SERVICE_NAME;
		}
		const schema = SNOWPLOW_EVENTS_SCHEMA[name];
		const platforms = EVENT_PLATFORMS[name];
		if (!platforms || platforms.length === 0) {
			throw new Error(`No platforms configured for event: ${name}`);
		}
		platforms.forEach((platform) => {
			switch (platform) {
				case SNOWPLOW:
					if (!schema) throw new Error(`schema not found for ${name}`);
					__MB_Analytics?.sendToSnowplow(schema, payload, contexts);
					break;
				case EVENTSLOG:
					__MB_Analytics?.logEvent(name, payload);
					break;
				case NETCORE:
					__MB_Analytics?.sendToNetcore(name, payload);
					break;
				default:
					console.warn(`Unknown platform: ${platform}`);
			}
		});
	} catch (ex) {
		console.log("Error in sending events", ex);
	}
};

export { __MB_Analytics, sendAnalyticsEvents };
